import React, { FC } from 'react';
import { classes, style } from 'typestyle';
import { typeCompact14Regular } from '@traceair/tds';
import InvoicingWindow from './invoicing/InvoicingWindow';
import DocumentsWindow from './documents/DocumentsWindow';
import { SidebarPanel, useAppStore } from '../../store/appStore';
import { MissionCustomer } from '../../types';
import './react-datepicker.css';
import { MissionsPage } from './missions/MissionsPage';

interface MainContentProps {
  selectedPanel: SidebarPanel;
  missions: MissionCustomer[];
}

const MainContent: FC<MainContentProps> = ({ selectedPanel }) => {
  const contentMap = {
    MISSIONS: <MissionsPage />,
    INVOICING: <InvoicingWindow />,
    DOCUMENTS: <DocumentsWindow />,
  };

  return contentMap[selectedPanel] || null;
};

const MainContainer: FC = () => {
  const { selectedSidebarPanel, missions } = useAppStore();

  return (
    <div className={classes('main-container', mainContainerStyle, typeCompact14Regular)}>
      {selectedSidebarPanel && <MainContent selectedPanel={selectedSidebarPanel} missions={missions ?? []} />}
    </div>
  );
};

// Styles
const mainContainerStyle = style({
  display: 'flex',
  position: 'relative',
  height: '100%',
  width: '100%',
});

export default MainContainer;
